<div class="modal-dialog">
<div class="modal-content">
  <div class="modal-header">Rename file</div>
  <div class="modal-body cl-form">

    <label for="dest_name" class="form-label">New file name</label>
    <input id="dest_name" type="text" [(ngModel)]="dest_name">

  </div>
  <div class="modal-footer">
    <span class="modal-footer-left cl-spacing-box cl-spacing-none">
                    <button type="button" class="btn cl-color-secondary it-cancel"
                            (click)="close()">
                        <span>Cancel</span>
                    </button></span>
    <span class="modal-footer-center">
        <div style="margin-top: -8px;">
          <app-message-field #moveMsg/>
        </div>
      </span>
    <span class="modal-footer-right">
                    <app-do-button type="button" buttonClass="btn cl-color-primary" [messageField]="moveMsg" (actionTriggered)="rename($event);">
                        <span>Rename file</span>
                    </app-do-button>
      </span>
  </div>
  </div>
</div>
